import React, { useEffect, useState } from 'react';
import fullLogo from "../assets/icons/full-logo.png";
import { getUserName, getUserRole } from '../utils/localStoarege';
import { getAddress } from '../services/clinic/invoice';
import { toast } from 'react-toastify';
import CustomLoading from './customLoading/CustomLoading';
import loadingIcon from "../assets/icons/part-logo.png";

const MedicineReceiptComponent = ({ name, amount, paymentMode, receiptNo, phonePayNo, amountInWords, medicines, machieName = getUserName(), date }) => {
    const [contact_number, setAddress] = useState("");
    const [bank_account_number, setBankAccountNumber] = useState("HDFC BANK A/C No. 50200063222650");
    const [loading, setLoading] = useState(false);


    const fetchData = async (centerName) => {
        if (getUserRole() === "operator") {
            setLoading(true);
            try {
                let res = await getAddress(centerName);
                if (res.status === 200) {
                    setAddress(res.data.results[0].contact_info);
                    setBankAccountNumber(res.data.results[0].bank_account_number);
                } else {
                    toast.error("Unable to fetch Address");
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching Machines:", error);
            } finally {
                setLoading(false);
            }
        }
    };


    useEffect(() => {
        fetchData(getUserName());
    }, []);


    return (
        loading ? <div className="flex max-w-2xl flex-col justify-center items-center min-w-64 min-h-64">
            <CustomLoading imageSrc={loadingIcon} size={75} />
        </div>
            :
            <div className="bg-white shadow-md rounded-lg p-6 max-w-2xl">
                {/* Header Section */}
                <div className="text-center mb-4">
                    <div className="flex flex-row justify-center w-full">
                        <img src={fullLogo} className='max-h-10' alt="HUD-Logo" />
                    </div>
                    <p className="text-[0.8rem] font-bold">Dr. Sanjay Dubey</p>
                    <p className="text-[0.6rem] text-gray-600">HO. INDORE<br /> Branches Located At:
                        Nagpur, Ahmedabad, Pune, Delhi, Mumbai, Vadodara, Raipur, Surat, Hyderabad, and Bangalore</p>
                    <p className="text-[0.6rem] text-gray-600">{contact_number.length !== 0 ? contact_number : machieName}</p>
                    <p className="text-[0.6rem] text-gray-600">E-Mail: info@maharshivitiligo.com</p>
                    <p className="text-[0.6rem] text-gray-600"><a href="https://www.maharshivitiligo.com/" className='underline text-primary'>www.maharshivitiligo.com</a></p>
                </div>

                {/* Receipt Info */}
                <div className="items-center border-t border-b py-2 mb-4">
                    <div className="flex justify-between">
                        <p className="text-sm">Medicine Receipt</p>
                        <p className="text-[0.8rem] text-gray-600">
                            Dated: {date || new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(new Date())}
                        </p>
                    </div>
                </div>

                {/* Details Section */}
                <div className="mb-1">
                    <p className="text-[0.6rem] text-gray-700">No. : <span className="font-medium">{receiptNo}</span></p>
                    {
                        paymentMode === "Cash" ?
                            <></>
                            :
                            <p className="text-sm text-gray-700">Through: <span className="font-medium">{bank_account_number}</span></p>
                    }
                </div>
                <div className="flex flex-col my-2">
                    {medicines.map((item) => <div className='flex flex-row justify-between'><p className='text-gray-500 text-[0.8rem]'>{item.medicine_name}</p><p className='text-black font-bold text-[0.8rem]'>{item.quantity} X ₹{item.price}</p></div>)}
                </div>
                {/* Account Section */}
                <div className="mb-6 border-b">
                    <p className="text-[0.6rem] font-medium text-gray-700">Account: {name}</p>
                    <p className="text-[0.6rem] text-gray-600">On Account: {paymentMode}</p>
                </div>

                {/* Amount Section */}
                <div className="flex justify-between items-center mb-6">
                    <p className="text-sm text-gray-600">Amount:</p>
                    <p className="text-xl font-bold text-gray-800">₹ {amount.toLocaleString()}</p>
                </div>

                {/* Amount in Words and Payment Details */}
                <div className="mb-6">
                    <p className="text-[0.8rem] text-gray-600">On Account of: Phone Pay No: {phonePayNo}</p>
                    <p className="text-[0.8rem] text-gray-600">Amount (in words): {amountInWords}</p>
                </div>

                {/* Footer */}
                <div className="mt-10 text-end">
                    <p className="text-[0.8rem] font-medium text-gray-700">____________________</p>
                    <p className="text-[0.8rem] font-medium text-gray-700">Authorised Signatory</p>
                </div>
            </div >
    );
};

export default MedicineReceiptComponent;
